
import { connect } from "react-redux";
import { SA_Wlf } from "./sa-wlf";

const mapDispatchToProps = dispatch => {
  return {}
};

const mapStateToProps = state => {
  return {
    token: state.user.token,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SA_Wlf);
